import { registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './core/layouts/auth/auth.layout';
import { BaseLayoutComponent } from './core/layouts/base/base.layout';
import { UserResolverService } from './core/services/auth/user-resolver.service';
import { ConfigurationResolverService } from './core/services/configuration/configuration.resolver.service';
import { DataResolverService } from './core/services/data/data-resolver.service';

registerLocaleData(locale, 'locale');

const routes: Routes = [
  {
    path: 'app',
    component: BaseLayoutComponent,
    resolve: {
      userData: UserResolverService,
      dataData: DataResolverService,
      configurationData: ConfigurationResolverService,
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'offers',
        loadChildren: () => import('./modules/offers/offers.module').then((m) => m.OffersModule),
      },
      {
        path: 'clicks',
        loadChildren: () => import('./modules/clicks/clicks.module').then((m) => m.ClicksModule),
      },
      {
        path: 'billing',
        loadChildren: () => import('./modules/invoices/invoices.module').then((m) => m.InvoicesModule),
      },
      {
        path: 'conversions',
        loadChildren: () => import('./modules/conversions/conversions.module').then((m) => m.ConversionsModule),
      },
      {
        path: 'affiliate-trackers',
        loadChildren: () => import('./modules/affiliate-trackers/affiliate-trackers.module').then((m) => m.AffiliateTrackersModule),
      },
      {
        path: 'smart-links',
        loadChildren: () => import('./modules/smart-links/smart-links.module').then((m) => m.SmartLinksModule),
      },
      {
        path: 'changelog',
        loadChildren: () => import('./modules/changelog/changelog.module').then((m) => m.ChangelogModule),
      },
      {
        path: 'account-protection',
        loadChildren: () => import('./modules/account-protection/account-protection.module').then((m) => m.AccountProtectionModule),
      },
      {
        path: 'reporting',
        loadChildren: () => import('./modules/reporting/reporting.module').then((m) => m.ReportingModule),
      },
      {
        path: 'drilldown',
        loadChildren: () => import('./modules/drilldown/drilldown.module').then((m) => m.DrilldownModule),
      },
      {
        path: 'comparing-analytics',
        loadChildren: () => import('./modules/comparing-analytics/comparing-analytics.module').then((m) => m.ComparingAnalyticsModule),
      },
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
    resolve: {
      configurationData: ConfigurationResolverService,
    },
  },
  { path: '', redirectTo: 'app/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'app/dashboard' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      paramsInheritanceStrategy: 'always',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
